import { Component } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  providers: [NgbCarouselConfig],
  selector: 'app-client-carousel',
  styleUrls: ['./client-carousel.component.scss'],
  templateUrl: './client-carousel.component.html'
})

export class ClientCarouselComponent {
  showNavigationArrows = false;
  showNavigationIndicators = false;
  images = [1, 2, 3].map(() => `https://picsum.photos/900/500?random&t=${Math.random()}`);

  constructor(config: NgbCarouselConfig) {
    // customize default values of carousels used by this component tree
      config.showNavigationArrows = false;
      config.showNavigationIndicators = false;
  }
}
